import React from 'react';
import { XIcon } from 'lucide-react';
import { LoyaltyPointsSection } from './LoyaltyPointsSection';
interface LoyaltyPointsBottomSheetProps {
  isOpen: boolean;
  onClose: () => void;
}
export function LoyaltyPointsBottomSheet({
  isOpen,
  onClose
}: LoyaltyPointsBottomSheetProps) {
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-end" data-id="element-691" data-mp="2yjsyv3jrd5gz">
      <div className="bg-white rounded-t-xl w-full max-h-[90vh] overflow-y-auto" data-id="element-692" data-mp="21vn0gydfj9b5">
        <div className="sticky top-0 bg-white border-b border-gray-200 flex items-center justify-between p-4 z-10" data-id="element-693" data-mp="25w6tpquvtss0">
          <h2 className="text-lg font-bold" data-id="element-694" data-mp="2ava13hyc4b35">Loyalty Points</h2>
          <button onClick={onClose} className="p-2 rounded-full hover:bg-gray-100" data-id="element-695" data-mp="2axw6baxr6ei7">
            <XIcon className="w-5 h-5 text-gray-500" data-id="element-696" data-mp="3maymi4vxx21u" />
          </button>
        </div>
        <div className="p-4" data-id="element-697" data-mp="3r9t5p7xtksmh">
          <LoyaltyPointsSection data-id="element-698" data-mp="3r9056opgezcs" />
        </div>
      </div>
    </div>;
}